var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#iconPhone_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fillOpacity: 0.12,
    rx: 3.333
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.36,
    fillRule: "evenodd",
    d: "M8.155 3.722q-.106.041-.204.097l-.748.433-.333.189c-.246.139-.426.37-.5.643-.592 2.195-.175 4.51.89 6.354 1.07 1.854 2.865 3.372 5.062 3.951.268.071.548.022.79-.117l.909-.526c.129-.079.085-.06.223-.146.613-.387.8-1.193.416-1.802l-.04-.06-.06-.078-1.53-1.834-.065-.073a1.57 1.57 0 0 0-1.92-.28l-.81.462-.077-.07a4 4 0 0 1-.646-.776l-.066-.111a2.8 2.8 0 0 1-.283-.792l-.007-.04.833-.48c.666-.385.959-1.19.693-1.906l-.844-2.276a1.303 1.303 0 0 0-1.597-.79zm.331.995a.26.26 0 0 1 .315.111l.02.043.847 2.273a.52.52 0 0 1-.175.598l-.053.034-1.416.818q.056 1.22.588 2.06.478.757 1.307 1.406l.188.143 1.425-.812a.52.52 0 0 1 .616.074l.042.046 1.526 1.834a.26.26 0 0 1-.062.387l-.386.24-.36.219q-.175.104-.336.197c-2.135-.572-3.627-2.115-4.411-3.473-.779-1.349-1.37-3.413-.801-5.554l.512-.292.574-.332z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconPhone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconPhone;